import { Trabalhodenunciante } from '../entrevistas/trabalhodenunciante';

export class Entrevista{
  id: number;
  identif: string;
  nome: string;
  email: string;
  telefone: string;
  alunoFM: boolean;
  tecAdmTercOutro: boolean;
  docenteTecSup: boolean;
  matricula: string;
  dataNascimento: Date;
  profissao: string;
  filhos: number;
  qtdFilhos: number;
  idadeFilhos: string;
  atuaGraduacao: string;
  atuaPosLato: string;
  atuaPosStricto: string;
  atuaExtensao: string;
  atuaPesquisa: string;
  curso: string;
  periodo: string;
  nomeAtividade: string;
  sexo: number;
  outroSexo: string;
  etnia: number;
  estadocivil: number;
  escolaridade_id: number;
  trabalhodenunciante: Trabalhodenunciante;
  denuncia_id: number;
  outroLocal: string;
  servicoDepto: string;
  tempoSetor: string;
  cargo: string;
  tempoCargo: string;
  funcao: string;
  tempoFuncao: string;
  jornada: string;
  tempoServicoInst: string;
  outroContrato: string;
  itensLocalTrabalhoFinal: number[];
  itensTipoContratoFinal: number[];
  outrasInformacoes: string;
  providencias: string;
  impressoesGerais: string;
  locais: number[];
  contratos: number[];
  outroContratoTrabalho: string;
  outroLocalTrabalhoEstudo: string;

  constructor(){
    this.trabalhodenunciante = new Trabalhodenunciante;
  }
}



// WEBPACK FOOTER //
// ./src/app/entrevista/entrevista.ts